if (!customElements.get('ac-sale-countdown')) {
  class AcSaleCountdown extends HTMLElement {
    connectedCallback() {
      this.endTime = Date.parse(this.getAttribute('end-at') || '');
      this.units = this.querySelector('[data-countdown-units]');
      this.expired = this.querySelector('[data-countdown-expired]');

      if (Number.isNaN(this.endTime)) {
        this.hidden = true;
        return;
      }

      this.update();
      this.interval = window.setInterval(() => this.update(), 1000);
    }

    disconnectedCallback() {
      window.clearInterval(this.interval);
    }

    update() {
      const remaining = Math.max(0, this.endTime - Date.now());

      if (remaining <= 0) {
        window.clearInterval(this.interval);
        this.units.hidden = true;
        this.expired.hidden = false;
        this.expired.textContent = this.getAttribute('expired-text') || 'This offer has ended.';
        return;
      }

      const days = Math.floor(remaining / 86400000);
      const hours = Math.floor((remaining % 86400000) / 3600000);
      const minutes = Math.floor((remaining % 3600000) / 60000);
      const seconds = Math.floor((remaining % 60000) / 1000);

      this.querySelector('[data-days]').textContent = String(days).padStart(2, '0');
      this.querySelector('[data-hours]').textContent = String(hours).padStart(2, '0');
      this.querySelector('[data-minutes]').textContent = String(minutes).padStart(2, '0');
      this.querySelector('[data-seconds]').textContent = String(seconds).padStart(2, '0');
    }
  }

  customElements.define('ac-sale-countdown', AcSaleCountdown);
}
